export function toTitleCase(input: string): string {
  if (!input) return '';

  return input
    // handle snake_case & kebab-case
    .replace(/[_-]/g, ' ')
    // handle camelCase
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    // capitalize each word
    .replace(/\w\S*/g, (word) =>
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .trim();
}